import Image from "@ingka/image";
import Text from "@ingka/text";
import Hyperlink from "@ingka/hyperlink";
import { bynderBaseUrl } from "@/api";
import { SimilaritySearchAssetDto } from "generated";
import { useAuth } from "@/hooks/auth";

type Props = {
  file: SimilaritySearchAssetDto;
};

const SimilarImageCard = ({ file }: Props) => {
  const { isIngkaUser } = useAuth().user;

  return (
    <div className="image-card">
      <Image
        className="mb-space50 h-[10rem] w-full object-cover"
        src={file.url}
        alt={file.name || "Similar asset image"}
      />
      <div className="flex flex-col">
        <Text tagName="span" bodySize="s">
          Name: {file.name}
        </Text>
        <Text tagName="span" bodySize="s">
          Usage rights: {file.usageRights?.join(",")}
        </Text>
        {isIngkaUser && (
          <Hyperlink
            newWindow
            text={
              <Text tagName="span" bodySize="s">
                View in Ingka DAM
              </Text>
            }
            url={`${bynderBaseUrl}/media/?mediaId=${file.id}&viewType=grid`}
          />
        )}
      </div>
    </div>
  );
};

export default SimilarImageCard;
